import React, { useEffect } from 'react';
import clsx from 'clsx';
import { Skeleton } from 'app/components/Material/Skeleton';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  skeletonContainer: {
    maxWidth: '854px',
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  firstRowContainer: {
    width: '100%',
    height: '120px',
    display: 'flex',
    marginBottom: '10px',
  },
  secondRowContainer: {
    width: '100%',
    height: '64px',
    display: 'flex',
  },
  thirdRowContainer: {
    width: '100%',
    display: 'flex',
    margin: '30px 0 20px 0',
    justifyContent: 'space-between',
  },
  firstBlock: {
    display: 'flex',
    width: '100%',
  },
  secondBlock: {
    display: 'flex',
  },
  firstBlockSkeletonItem: {
    width: '170px',
  },
  secondBlockSkeletonItem: {
    width: '250px',
  },
  skeletonItem: {
    height: '100%',
    margin: '0 16px',
    borderRadius: '6px',
    flex: 1,
  },
  fullRowSkeletonItem: {
    marginTop: '10px',
  },
}));

export const TeamSkeletonLoading = (props) => {
  const skeletonTableLoadingLastPartRows = Array.from(
    { length: 10 },
    (_, i) => i + 1,
  );
  const classes = useStyles();
  useEffect(() => {
    if (
      !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator?.userAgent,
      )
    ) {
      // to make screen scrollable on loading with phone
      document.body.classList.add('overflow-hidden');
    }
    return () => {
      document.body.classList.remove('overflow-hidden');
    };
  }, []);
  return (
    <div className={classes.skeletonContainer}>
      <div className={classes.thirdRowContainer}>
        <Skeleton
          animation="wave"
          variant="rect"
          height={'40px'}
          width={'150px'}
          className={clsx(classes.skeletonItem, classes.fullRowSkeletonItem)}
        />
        <Skeleton
          animation="wave"
          variant="rect"
          height={'40px'}
          width={'215px'}
          className={clsx(classes.skeletonItem, classes.fullRowSkeletonItem)}
        />
      </div>
      {skeletonTableLoadingLastPartRows.map((item, index) => (
        <Skeleton
          key={index}
          animation="wave"
          variant="rect"
          height={'80px'}
          className={clsx(classes.skeletonItem, classes.fullRowSkeletonItem)}
        />
      ))}
    </div>
  );
};
